import _ from 'lodash'

const DEFAULT_COLUMNS = [
  { key: 'Objektnr', default: '', name: 'Objektnr', sortKey: 'Objektnr', readonly: true, selected: true },
  { key: 'Katalogtekst1', default: '-', name: 'Katalogtekst1', sortKey: 'Katalogtekst1', tooltip: true, selected: true },
  { key: 'Navn', default: '', name: 'Navn', sortKey: 'Navn', readonly: true, selected: true },
  { key: 'Mobil', default: '-', name: 'Mobil.', sortKey: 'Mobil', class: '', selected: true },
  { key: 'Antall', default: '-', name: 'Antall', sortKey: 'Antall', class: '', selected: true },
  { key: 'Bet_dato', default: '', name: 'Bet_dato', sortKey: 'Bet_dato', selected: true },
  { key: 'Destinasjon', default: '', name: 'Destinasjon', sortKey: 'Destinasjon', selected: true }
]

const LS_KEY = 'vinpakkeliste-search-values'
const LS_KEY_COLS = 'columns'

const state = {
  defaultColumns: null
}

const loadLs = (key = null) => {
  try {
    const retval = JSON.parse(localStorage.getItem(LS_KEY) || {})

    if (key === null) {
      return retval
    }

    if (!retval.hasOwnProperty(key)) {
      return null
    }

    return retval[key]
  } catch (e) {
    return null
  }
}

const saveLs = (key, data) => {
  try {
    const stored = loadLs() || {}
    stored[key] = data
    localStorage.setItem(LS_KEY, JSON.stringify(stored))
  } catch (e) {
    // Ignore
  }
}

const getters = {
  columns: state => {
    if (!state.defaultColumns) {
      let retval = loadLs(LS_KEY_COLS) || DEFAULT_COLUMNS

      // How we get possibly new cols added...
      if (retval !== DEFAULT_COLUMNS) {
        retval = _.uniqBy([...retval, ...DEFAULT_COLUMNS], 'key')
      }

      return retval
    }

    return state.defaultColumns
  }
}

const actions = {
  saveColumns: ({commit, dispatch}, payload) => {
    return new Promise((resolve, reject) => {
      commit('saveColumns', payload)
      resolve()
    })
  },
  resetColumns: ({commit, dispatch}) => {
    return new Promise((resolve, reject) => {
      commit('resetColumns')
      resolve()
    })
  }
}

const mutations = {
  'saveColumns': (state, payload) => {
    state.defaultColumns = payload
    saveLs(LS_KEY_COLS, payload)
  },
  'resetColumns': (state) => {
    state.defaultColumns = DEFAULT_COLUMNS
    saveLs(LS_KEY_COLS, DEFAULT_COLUMNS)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/vinpakkeliste.js